import {t} from '../../../common/getTranslations';
import {requestContext} from '../../../common/requestContext';
import {SalesTicketVo} from '../../../common/shared/api/nicolas/vo/SalesTicketVo.interface';
import {SaleTypeVo} from '../../../common/shared/api/nicolas/vo/SaleTypeVo.enum';
import {getTicketTitle} from './getTicketTitle.function';

export function getSalesTicketTitle(salesTicket: SalesTicketVo): string {
  const isEn = requestContext.requestInfo.lang.deviceLang === 'en';
  const ticketTitle = getTicketTitle(salesTicket.ticket_type);
  const value =
    salesTicket.sale_type === SaleTypeVo.Sale
      ? salesTicket.item_count * salesTicket.qty
      : Math.abs(salesTicket.paid_num);
  const ticketCount = t('common_ticket_amount', {
    values: {
      value,
    },
  });

  const pluralSuffix =
    isEn && ticketTitle.toLowerCase().endsWith('pass') ? '(es)' : '';

  // 영문의 경우 {ticketTitle} {ticketCount} 로 보여줄 경우
  // {some_value} pass {amount_value} pass 와 같이 pass가 중복 노출되고 있습니다.
  // 영문에서만 제목 구성을 변경하여 아래와 같이 pass가 한번 노출되도록 처리합니다.
  return isEn
    ? `${value} ${ticketTitle}${pluralSuffix}`
    : `${ticketTitle} ${ticketCount}`;
}
